import {
    GET_CURRENT_TECHNOLOGY
} from './constants';

const initialState = {
    currentTechnology: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_TECHNOLOGY: {
            return {
                ...state,
                currentTechnology: action.payload,
            };
        }
        default:
            return state;
    }
};

